// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"5ebdf9d8","520":"fb60c1f9"}[chunkId] + ".chunk.js";
};